import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazineAnalyticsSettingPresenter } from "./presenter";
import { useMagazineAnalyticsQuery } from "../../model/repository/query/use-magazine-analytics-setting-query";

type Props = {
	hotelID: string;
};

export const DesignMagazineAnalyticsSettingContainer = memo(({ hotelID }: Props) => {
	const { data } = useMagazineAnalyticsQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazineAnalyticsSettingPresenter hotelID={hotelID} serverModel={data} />;
});

DesignMagazineAnalyticsSettingContainer.displayName = "DesignMagazineAnalyticsSettingContainer";
